module.exports = __webpack_public_path__ + "img/product-comment.25e10115.svg";